import { createApi } from '@reduxjs/toolkit/query/react';
import { apiResources } from 'src/common/Constants';
import type { TTransporterRate, TRatesRequestDTO } from 'src/common/types/transporter.type';
import type { TSearchFilter, TSearchResponse } from 'src/typings/app.type';
import { baseQueryWithAuth, transformResponses } from '../rtkq.interceptor';

const transporterTag = 'transporter';
export const transporterApi = createApi({
  reducerPath: 'transporterApi',
  tagTypes: [transporterTag],
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getRates: builder.query<TSearchResponse<TTransporterRate>, TSearchFilter & TRatesRequestDTO>({
      providesTags: [transporterTag],
      query: (params) => ({ url: `${apiResources.transporterRate}/all`, params }),
      ...transformResponses,
    }),
    deleteRate: builder.mutation<string, number[]>({
      query: (rateIds) => ({ url: `${apiResources.transporterRate}/delete`, method: 'DELETE', body: { rateIds } }),
      ...transformResponses,
      invalidatesTags: (_result, error) => (error ? [] : [transporterTag]),
    }),
    uploadRates: builder.mutation<string, File>({
      query: (xlsx) => {
        const body = new FormData();
        body.append('file', xlsx);
        return { url: `${apiResources.transporterRate}/upload`, method: 'POST', body };
      },
      ...transformResponses,
      invalidatesTags: (_result, error) => (error ? [] : [transporterTag]),
    }),
  }),
});

export const { useGetRatesQuery, useUploadRatesMutation, useDeleteRateMutation } = transporterApi;
